import StatusCardExamples from './StatusCard';
import HealthTiles from './HealthTiles';
import HealthCountsExamples from './HealthCounts';
import HealthStatusCardExamples from './HealthStatusCard';
import RatioBarExamples from './RatioBar';
import HealthRatioBarExamples from './HealthRatioBar';
import SingleValueExamples from './SingleValue';
import URLParamsExamples from './UrlParams';
import SelectEamples from './Select';
import DropdownExamples from './Dropdown';
import ProductResourceExamples from './ProductResources';
import RecentlyVisitedExamples from './RecentlyVisited';

import example1 from '../../../../solutions/dashify-docs/objects/dashboard/tabs/example1.json';
import example2 from '../../../../solutions/dashify-docs/objects/dashboard/tabs/example2.json';
import example3 from '../../../../solutions/dashify-docs/objects/dashboard/tabs/example3.json';
import tabs from '../../../../solutions/dashify-docs/objects/dashboard/tabs/tabs.json';

import GlobalsExamples from './Globals';

export default [
  ...StatusCardExamples,
  ...HealthStatusCardExamples,
  ...RatioBarExamples,
  ...HealthCountsExamples,
  ...HealthRatioBarExamples,
  ...HealthTiles,
  ...SingleValueExamples,
  ...URLParamsExamples,
  ...SelectEamples,
  ...DropdownExamples,
  ...ProductResourceExamples,
  ...RecentlyVisitedExamples,
  ...GlobalsExamples,
  tabs,
  example1,
  example2,
  example3,
];
